// Ajax Cart Logic

document.addEventListener('DOMContentLoaded', () => {
  const openCartBtn = document.getElementById('openCart');
  const closeCartBtn = document.getElementById('closeCart');
  const cartOverlay = document.getElementById('cartOverlay');
  const continueBtn = document.getElementById('continueBtn');
  const checkoutBtn = document.getElementById('checkoutBtn');

  // Drawer functions
  const openCart = () => {
    cartOverlay.style.display = 'block';
    // Small delay to allow CSS display:block to apply before animation
    setTimeout(() => {
      cartOverlay.setAttribute('aria-hidden', 'false');
    }, 10);
    fetchCart();
  };

  const closeCart = () => {
    cartOverlay.setAttribute('aria-hidden', 'true');
    setTimeout(() => {
      cartOverlay.style.display = 'none';
    }, 300); // match transition duration
  };

  if (openCartBtn) openCartBtn.addEventListener('click', openCart);
  if (closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
  if (continueBtn) continueBtn.addEventListener('click', closeCart);
  if (cartOverlay) {
    cartOverlay.addEventListener('click', (e) => {
      if (e.target === cartOverlay) closeCart();
    });
  }

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', () => {
      window.location.href = '/checkout';
    });
  }

  // Format money function
  const formatMoney = (cents) => {
    return '¥' + (cents / 100).toLocaleString();
  };

  // Fetch Cart from Shopify API
  const fetchCart = () => {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        renderCart(cart);
      })
      .catch(error => console.error('Error fetching cart:', error));
  };

  // Render Cart
  const renderCart = (cart) => {
    const cartItemsContainer = document.getElementById('cartItems');
    const cartTotalElement = document.getElementById('cartTotal');
    const cartCountElement = document.getElementById('cartCount');
    const cartItemsBadge = document.getElementById('cartItemsBadge');

    if (cartCountElement) cartCountElement.textContent = cart.item_count;
    if (cartItemsBadge) cartItemsBadge.textContent = `${cart.item_count} items`;
    if (cartTotalElement) cartTotalElement.textContent = formatMoney(cart.total_price);

    if (cart.items.length === 0) {
      cartItemsContainer.innerHTML = '<div style="text-align:center; padding:20px; color:var(--muted);">カートは空です。</div>';
      return;
    }

    let itemsHtml = '';
    cart.items.forEach(item => {
      itemsHtml += `
        <div class="cart-item">
          <div class="ci-img">
            <img src="${item.image || ''}" alt="${item.product_title}" />
          </div>
          <div>
            <h4>${item.product_title}</h4>
            <div class="ci-meta">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
            <div class="ci-meta">${formatMoney(item.original_price)}</div>
            <div class="ci-row">
              <div class="qty">
                <button type="button" onclick="changeItemQty('${item.key}', ${item.quantity - 1})">-</button>
                <span>${item.quantity}</span>
                <button type="button" onclick="changeItemQty('${item.key}', ${item.quantity + 1})">+</button>
              </div>
              <button class="btn ghost" type="button" style="padding:6px 10px; font-size:12px;" onclick="changeItemQty('${item.key}', 0)">削除</button>
            </div>
          </div>
        </div>
      `;
    });
    cartItemsContainer.innerHTML = itemsHtml;
  };

  // Expose change qty function
  window.changeItemQty = (lineKey, newQty) => {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity: newQty
      })
    })
      .then(response => response.json())
      .then(cart => {
        renderCart(cart);
      })
      .catch(error => console.error('Error updating cart:', error));
  };

  // Initial fetch to show count
  fetchCart();
});

// Add to Cart via Ajax (for product page)
window.addToCartAjax = (e, button) => {
  e.preventDefault();
  const form = document.getElementById('add-to-cart-form');
  const msgDiv = document.getElementById('ajaxCartMsg');
  if (!form) return;

  const formData = new FormData(form);
  button.disabled = true;
  button.textContent = '追加中...';
  if (msgDiv) msgDiv.textContent = '';

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
    .then(response => response.json())
    .then(item => {
      button.disabled = false;
      button.textContent = 'カートに追加';
      if (msgDiv) {
        msgDiv.textContent = 'カートに追加しました！';
        msgDiv.style.color = 'var(--ok)';
      }
      document.getElementById('openCart').click(); // Open drawer
    })
    .catch(error => {
      console.error('Error:', error);
      button.disabled = false;
      button.textContent = 'カートに追加';
      if (msgDiv) {
        msgDiv.textContent = 'エラーが発生しました。';
        msgDiv.style.color = 'var(--danger)';
      }
    });
};
